"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Logo = void 0;
var Logo_1 = __importDefault(require("./Logo"));
exports.Logo = Logo_1.default;
exports.default = Logo_1.default;
//# sourceMappingURL=index.js.map